import * as React from 'react'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import { useState, useEffect } from 'react'
import { toastError, toastSuccess } from '../../util/toastUtil'
import { useCustomAxios } from '../../axiosInstance'
import Input from '../../components/Input/Input'
import { useNavigate, useLocation } from 'react-router-dom'
import {
    Box,
    Button,
    InputLabel,
    MenuItem,
    Select,
    Typography,
} from '@mui/material'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import {
    ACCOUNT_ENDPOINTS,
    LOGINQA_ENDPOINTS,
    REGISTER_ENDPOINTS,
} from '../../constants/apiConstants'
import { NAVIGATION_LINKS, baseURLRoute } from '../../constants/routeConstants'
import MaskedInput from '../../components/MaskedInput/MaskedInput'
import logo from '../../assets/Images/TMDSAS_Logo_2020.png'
import './updateProfile.css'
import CONFIG from '../../constants/urlConstants'
import NoteSectionUpdateProfile from './NoteSectionUpdateProfile'

const UpdateProfile = ({
    setUser,
    setLoadingDataGlobal,
    // letterRequestEmailId,
}) => {
    const axios = useCustomAxios()
    const [email, setEmail] = useState('')
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const navigate = useNavigate()
    const [questionlist, setQuestionlist] = useState(null)
    const [phone, setPhone] = useState('')
    const [selectedRadioOptIn, setSelectedRadioOptIn] = useState(null)
    const [portalId, setPortalId] = useState(0)
    const [scrollToTop, setScrollToTop] = useState(false)
    const [question, setQuestion] = useState([
        { loginQuestionId: 2, answer: '' },
        { loginQuestionId: 4, answer: '' },
        { loginQuestionId: 7, answer: '' },
    ])
    const location = useLocation()

    useEffect(() => {
        let isSubscribed = true
        const user = sessionStorage.getItem('user')
        let userData = JSON.parse(user)
        if (userData.hasProfile) {
            navigate(NAVIGATION_LINKS.DASHBOARD, {
                replace: true,
            })
        }

        const fetchque = async () => {
            const data = await axios
                .get(LOGINQA_ENDPOINTS.ALL)
                .then((response) => {
                    return response.data
                })
                .catch((err) => {
                    setLoadingDataGlobal(false)
                    toastError(
                        'Something went wrong, Please refresh the page and try again.'
                    )
                    // console.log(err);
                })
            if (isSubscribed) {
                setLoadingDataGlobal(false)
                setQuestionlist(data)
                setFirstName(userData.firstName)
                setLastName(userData.lastName)
                setEmail(userData.email)
            }
        }

        setLoadingDataGlobal(true)
        // call the function
        fetchque()
        //   // make sure to catch any error
        // .catch(console.error);

        return () => (isSubscribed = false)
    }, [])

    useEffect(() => {
        if (scrollToTop) {
            window.scrollTo(0, 0)
            setScrollToTop(false)
        }
    }, [scrollToTop])

    function ValidateEmail(mail) {
        if (/^[^@]+@[^@]+\.[^@]+$/.test(mail)) {
            return true
        }
        return false
    }

    const steps = ['Step 1: Contact Information', 'Step 2: Security Questions']
    const [activeStep, setActiveStep] = React.useState(0)

    const handleNext = async (e) => {
        e.preventDefault()

        const cellnumber = phone.replace(/\D/g, '')
        if (activeStep === 0) {
            if (firstName === '') {
                toastError('First Name is required.')
                return
            }
            if (lastName === '') {
                toastError('Last Name is required.')
                return
            }
            if (email === '') {
                toastError('Email Address is required.')
                return
            }
            if (!ValidateEmail(email)) {
                toastError('Please enter a valid email address.')
                return
            }
            if (selectedRadioOptIn == 1 && cellnumber.length === 0) {
                toastError('Mobile Number is required.')
                return
            }

            if (selectedRadioOptIn == 1 && cellnumber.length < 10) {
                toastError('Please enter a valid mobile number.')
                return
            }

            const ePayload = {
                // title: salutation,
                email: email,
                firstName: firstName,
                lastName: lastName,
                // middleName: middleName,
                // suffixId: parseInt(suffix),
                phoneNumber: cellnumber,
                // securityQuestions: userQA,
                // letterRequestEmailId: 0,
                optInSMS:
                    selectedRadioOptIn == 1
                        ? true
                        : selectedRadioOptIn == 0
                        ? false
                        : selectedRadioOptIn,
            }

            setLoadingDataGlobal(true)

            const result = await axios
                .post(ACCOUNT_ENDPOINTS.UPDATEPROFILE, ePayload)
                .then((response) => {
                    const user = response.data
                    setLoadingDataGlobal(false)
                    toastSuccess('User Data Updated Successfully')
                    return true
                })
                .catch((err) => {
                    setLoadingDataGlobal(false)
                    toastError(
                        err.response.data
                            ? err.response.data
                            : "Something went wrong, couldn't update user data, please try again"
                    )
                    return false
                    // console.log(err)
                })
            if (!result) {
                return
            }
        }

        if (activeStep === 1) {
            let isSubscribed = true

            if (
                question[0].answer === '' ||
                question[1].answer === '' ||
                question[2].answer === ''
            ) {
                toastError('Please answer all the questions.')
                return
            }

            const ePayload = [
                {
                    loginQuestionId: question[0].loginQuestionId,
                    answer: question[0].answer,
                },
                {
                    loginQuestionId: question[1].loginQuestionId,
                    answer: question[1].answer,
                },
                {
                    loginQuestionId: question[2].loginQuestionId,
                    answer: question[2].answer,
                },
            ]

            setLoadingDataGlobal(true)
            const user = sessionStorage.getItem('user')
            let userData = JSON.parse(user)
            userData.hasProfile = true
            const result = await axios
                .post(ACCOUNT_ENDPOINTS.UPDATESECURITYQUESTIONS, ePayload)
                .then((response) => {
                    const user = response.data
                    toastSuccess('User Questions Updated Successfully')

                    // call the function
                    setLoadingDataGlobal(false)
                    sessionStorage.setItem('user', JSON.stringify(userData))
                    return true
                    // make sure to catch any error
                    // .catch(console.error);
                })
                .catch((err) => {
                    setLoadingDataGlobal(false)
                    toastError(
                        err.response.data
                            ? err.response.data
                            : "Something went wrong, couldn't update user questions"
                    )
                    return false
                    // console.log(err);
                })

            if (!result) {
                return
            } else {
                setTimeout(() => {
                    navigate(NAVIGATION_LINKS.DASHBOARD, {
                        replace: true,
                    })
                }, 300)
            }

            // sessionStorage.setItem('user', JSON.stringify(userData))
            // setTimeout(() => {
            //     navigate(NAVIGATION_LINKS.DASHBOARD, {
            //         replace: true,
            //     })
            // }, 300)
        }
        if (activeStep !== steps.length - 1) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1)
        }
        setScrollToTop(true)
    }

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1)
        setScrollToTop(true)
    }

    const AsteriskLabel = (text) => {
        return (
            <label style={{ color: 'black' }}>
                {text}
                <span style={{ color: 'red', fontWeight: 'bold' }}>*</span> :
            </label>
        )
    }
    return (
        <>
            <section
                className="section"
                style={{
                    marginTop: '40px',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    width: 'auto',
                    maxWidth: 'auto',
                    padding: '20px',
                    backgroundColor: '#fff',
                    borderRadius: '5px',
                    boxShadow: '0px 0px 10px rgba(0,0,0,0.1)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                <Typography
                    variant="h6"
                    sx={{ color: 'red', fontWeight: 'bold' }}
                    gutterBottom>
                    Account information incomplete
                </Typography>
                <Typography
                    variant="body1"
                    sx={{
                        color: 'blue',
                        fontWeight: 'bold',
                        bgcolor: '#F5F5F5',
                    }}
                    gutterBottom>
                    Although your user account was created, you must submit your
                    Contact/Profile Information and answer Security Questions to
                    your letters of evaluation.
                </Typography>
                <Box sx={{ width: '100%' }}>
                    <Stepper activeStep={activeStep}>
                        {steps.map((label, index) => {
                            const stepProps = {}
                            const labelProps = {}

                            return (
                                <Step key={label} {...stepProps}>
                                    <StepLabel {...labelProps}>
                                        {label}
                                    </StepLabel>
                                </Step>
                            )
                        })}
                    </Stepper>
                    <React.Fragment>
                        {activeStep === 0 && (
                            <form
                                className="form"
                                style={{
                                    display: 'flex',
                                    flex: 1,
                                    flexDirection: 'column',
                                    maxWidth: '100%',
                                    boxShadow: 'none',
                                    padding: '0px',
                                    margin: '2rem 0 1rem 0',
                                }}>
                                <h4>Step 1 : Your contact information </h4>
                                <p> * denotes required data </p>
                                <InputLabel id="demo-simple-select-label">
                                    {AsteriskLabel('Full Legal First name')}
                                </InputLabel>
                                <Input
                                    type="text"
                                    name="firstname"
                                    disabled
                                    required
                                    style={{ marginBottom: '10px' }}
                                    value={firstName}
                                    id="firstName"
                                    onChange={(e) =>
                                        setFirstName(e.target.value)
                                    }
                                />
                                <InputLabel id="demo-simple-select-label">
                                    {AsteriskLabel('Full Legal Last name')}
                                </InputLabel>
                                <Input
                                    type="text"
                                    name="LastName"
                                    disabled
                                    required
                                    style={{ marginBottom: '10px' }}
                                    value={lastName}
                                    id="lastName"
                                    onChange={(e) =>
                                        setLastName(e.target.value)
                                    }
                                />
                                <InputLabel id="demo-simple-select-label">
                                    {AsteriskLabel('Email Address')}
                                </InputLabel>
                                <Input
                                    type="email"
                                    name="Email"
                                    disabled
                                    required
                                    style={{ marginBottom: '10px' }}
                                    value={email}
                                    id="email"
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                <div
                                    style={{
                                        display: 'flex',
                                        margin: '10px 0px',
                                        justifyContent: 'center',
                                        // width: '100%',
                                    }}>
                                    <RadioGroup
                                        aria-labelledby="demo-radio-buttons-group-label"
                                        name="radio-buttons-group"
                                        value={selectedRadioOptIn}
                                        style={{ alignSelf: 'center' }}
                                        onChange={(e) => {
                                            setSelectedRadioOptIn(
                                                e.target.value
                                            )
                                            setPhone('')
                                        }}>
                                        <FormControlLabel
                                            value={1}
                                            control={<Radio />}
                                            label="Yes"
                                        />

                                        <FormControlLabel
                                            value={0}
                                            control={<Radio />}
                                            label="No"
                                        />
                                    </RadioGroup>
                                    <NoteSectionUpdateProfile />
                                </div>

                                {selectedRadioOptIn == 1 ? (
                                    <>
                                        <InputLabel id="demo-simple-select-label">
                                            {AsteriskLabel('Mobile number')}
                                        </InputLabel>

                                        <MaskedInput
                                            type="text"
                                            id="phoneNumber"
                                            value={phone}
                                            name="phoneNumber"
                                            mask="(999) 999-9999"
                                            placeholder="(XXX) XXX-XXXX"
                                            required
                                            onChange={(e) =>
                                                setPhone(e.target.value)
                                            }
                                        />
                                    </>
                                ) : null}
                            </form>
                        )}

                        {/* {activeStep === 1 && (
                            <form
                                className="form"
                                style={{
                                    display: 'flex',
                                    flex: 1,
                                    flexDirection: 'column',
                                    maxWidth: '100%',
                                    boxShadow: 'none',
                                    padding: '0px',
                                    margin: '2rem 0 1rem 0',
                                }}>
                                <h4>Step 2: Username & Password Set-up</h4>
                                <p>
                                    The email address below will be used as your
                                    login name. This email address will also be
                                    used to contact you throughout the
                                    application process. This should be an email
                                    address that is active and which you check
                                    regularly.
                                </p>
                                <div>
                                    Email Address :<strong> {email} </strong>{' '}
                                </div>
                                <p>
                                    {' '}
                                    Create your password below. Passwords are
                                    case sensitive and must meet the following
                                    requirements:
                                    <ol>
                                        <li>At least 1 lower case letter</li>
                                        <li>At least 1 upper case letter</li>
                                        <li>At least 1 special character</li>
                                        <li>At least 1 number</li>
                                        <li>
                                            At least 10 characters in length
                                        </li>
                                    </ol>
                                </p>
                                <Input
                                    type="password"
                                    label={'Password'}
                                    value={password}
                                    id="password"
                                    htmlFor="password"
                                    onChange={(e) =>
                                        setPassword(e.target.value)
                                    }
                                />

                                <Input
                                    type="password"
                                    label={'Password Again'}
                                    value={passwordAgain}
                                    id="passwordagain"
                                    htmlFor="passwordagain"
                                    onChange={(e) =>
                                        setPasswordAgain(e.target.value)
                                    }
                                />
                            </form>
                        )} */}

                        {activeStep === 1 && (
                            <form
                                className="form"
                                style={{
                                    display: 'flex',
                                    flex: 1,
                                    flexDirection: 'column',
                                    maxWidth: '100%',
                                    boxShadow: 'none',
                                    padding: '0px',
                                    margin: '2rem 0 1rem 0',
                                }}>
                                <h4>Step 3: Security Questions</h4>
                                <p style={{ maxWidth: '100%' }}>
                                    Please select 3 of the following questions
                                    as your security questions. Should you ever
                                    need to reset your password, you will be
                                    prompted to answer one of the questions you
                                    select and to provide the same answer that
                                    you enter now. You will be required to also
                                    match the case you type here. You will be
                                    able to access your account and change your
                                    security questions or your answers at any
                                    time. Just click on the My Account link from
                                    the homepage.{' '}
                                </p>

                                <Select
                                    id="questionId"
                                    value={
                                        question[0].loginQuestionId
                                            ? question[0].loginQuestionId
                                            : ''
                                    }
                                    label="Question :"
                                    // labelId="Question"
                                    style={{
                                        background: '#f8fafc',
                                        height: '2em',
                                        minHeight: '2em',
                                        marginBottom: '10px',
                                    }}
                                    // onClick={callsuffixes()}

                                    onChange={(e) => {
                                        const newState = [...question]
                                        newState[0] = {
                                            ...newState[0],
                                            loginQuestionId: e.target.value,
                                        }
                                        setQuestion(newState)
                                    }}>
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {questionlist
                                        ? questionlist.map((item) => {
                                              if (
                                                  item.loginQuestionId ===
                                                      question[1]
                                                          .loginQuestionId ||
                                                  item.loginQuestionId ===
                                                      question[2]
                                                          .loginQuestionId
                                              ) {
                                                  item++
                                              } else {
                                                  return (
                                                      <MenuItem
                                                          key={
                                                              item.loginQuestionId
                                                          }
                                                          value={
                                                              item.loginQuestionId
                                                          }>
                                                          {
                                                              item.loginQuestionDescr
                                                          }
                                                      </MenuItem>
                                                  )
                                              }
                                          })
                                        : null}
                                </Select>
                                <Input
                                    type="text"
                                    name="answer"
                                    style={{ marginBottom: '10px' }}
                                    label={'Answer : '}
                                    value={question[0].answer}
                                    id="answer"
                                    onChange={(e) => {
                                        const newState = [...question]
                                        newState[0] = {
                                            ...newState[0],
                                            answer: e.target.value,
                                        }
                                        setQuestion(newState)
                                    }}
                                />

                                <Select
                                    id="questionId"
                                    value={
                                        question[1].loginQuestionId
                                            ? question[1].loginQuestionId
                                            : ''
                                    }
                                    label="Question :"
                                    labelId="Question"
                                    onChange={(e) => {
                                        const newState = [...question]
                                        newState[1] = {
                                            ...newState[1],
                                            loginQuestionId: e.target.value,
                                        }
                                        setQuestion(newState)
                                        if (
                                            newState[1].loginQuestionId ===
                                            question[0].loginQuestionId
                                        ) {
                                            toastError(
                                                'Previouseli selected question select new Question'
                                            )
                                            return
                                        }
                                    }}
                                    style={{
                                        background: '#f8fafc',
                                        height: '2em',
                                        minHeight: '2em',
                                        marginBottom: '10px',
                                    }}>
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {questionlist
                                        ? questionlist.map((item) => {
                                              if (
                                                  item.loginQuestionId ===
                                                      question[0]
                                                          .loginQuestionId ||
                                                  item.loginQuestionId ===
                                                      question[2]
                                                          .loginQuestionId
                                              ) {
                                                  item++
                                              } else {
                                                  return (
                                                      <MenuItem
                                                          key={
                                                              item.loginQuestionId
                                                          }
                                                          value={
                                                              item.loginQuestionId
                                                          }>
                                                          {
                                                              item.loginQuestionDescr
                                                          }
                                                      </MenuItem>
                                                  )
                                              }
                                          })
                                        : null}
                                </Select>
                                <Input
                                    type="text"
                                    name="answer"
                                    style={{ marginBottom: '10px' }}
                                    label={'Answer : '}
                                    value={question[1].answer}
                                    id="answer"
                                    onChange={(e) => {
                                        const newState = [...question]
                                        newState[1] = {
                                            ...newState[1],
                                            answer: e.target.value,
                                        }
                                        setQuestion(newState)
                                    }}
                                />
                                <Select
                                    id="questionId"
                                    value={
                                        question[2].loginQuestionId
                                            ? question[2].loginQuestionId
                                            : ''
                                    }
                                    label="Question :"
                                    labelId="Question"
                                    onChange={(e) => {
                                        const newState = [...question]
                                        newState[2] = {
                                            ...newState[2],
                                            loginQuestionId: e.target.value,
                                        }
                                        setQuestion(newState)
                                        if (
                                            newState[2].loginQuestionId ===
                                                question[0].loginQuestionId ||
                                            newState[2].loginQuestionId ===
                                                question[1].loginQuestionId
                                        ) {
                                            toastError(
                                                'Previouseli selected question select new Question'
                                            )
                                            return
                                        }
                                    }}
                                    style={{
                                        background: '#f8fafc',
                                        height: '2em',
                                        minHeight: '2em',
                                        marginBottom: '10px',
                                    }}>
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {questionlist
                                        ? questionlist.map((item) => {
                                              if (
                                                  item.loginQuestionId ===
                                                      question[0]
                                                          .loginQuestionId ||
                                                  item.loginQuestionId ===
                                                      question[1]
                                                          .loginQuestionId
                                              ) {
                                                  item++
                                              } else {
                                                  return (
                                                      <MenuItem
                                                          key={
                                                              item.loginQuestionId
                                                          }
                                                          value={
                                                              item.loginQuestionId
                                                          }>
                                                          {
                                                              item.loginQuestionDescr
                                                          }
                                                      </MenuItem>
                                                  )
                                              }
                                          })
                                        : null}
                                </Select>
                                <Input
                                    type="text"
                                    name="answer"
                                    style={{ marginBottom: '10px' }}
                                    label={'Answer : '}
                                    value={question[2].answer}
                                    id="answer"
                                    onChange={(e) => {
                                        const newState = [...question]
                                        newState[2] = {
                                            ...newState[2],
                                            answer: e.target.value,
                                        }
                                        setQuestion(newState)
                                    }}
                                />
                            </form>
                        )}

                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                pt: 2,
                            }}>
                            <Button
                                color="inherit"
                                disabled={activeStep === 0}
                                onClick={handleBack}
                                sx={{ mr: 1 }}>
                                Back
                            </Button>
                            <Box sx={{ flex: '1 1 auto' }} />
                            <Button onClick={handleNext}>
                                {activeStep === steps.length - 1
                                    ? 'Finish'
                                    : 'Next'}
                            </Button>
                        </Box>
                    </React.Fragment>
                    {/* )} */}
                </Box>
            </section>
        </>
    )
}
export default UpdateProfile
